// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import FupExerciseSettingListPagingResultModel from '../../model/fup-exercise-setting-list-paging-result-model';
import FupExerciseSettingListPagingResultDTO from '../dto/fup-exercise-setting-list-paging-result-dto';
import dtoSchema from '../schemas/fup-exercise-setting-list-paging-result-schema';
import FupExerciseSettingListModel from '../../model/fup-exercise-setting-list-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class FupExerciseSettingListPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<FupExerciseSettingListPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => FupExerciseSettingListModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: FupExerciseSettingListModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<FupExerciseSettingListPagingResultDTO>): FupExerciseSettingListPagingResultModel;
  static toModel(dto: DeepPartial<FupExerciseSettingListPagingResultDTO> | undefined | null): FupExerciseSettingListPagingResultModel | undefined;
  static toModel(dto: DeepPartial<FupExerciseSettingListPagingResultDTO> | undefined | null): FupExerciseSettingListPagingResultModel | undefined {
    return dto ? new FupExerciseSettingListPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<FupExerciseSettingListPagingResultModel> | FupExerciseSettingListPagingResultModel): FupExerciseSettingListPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as FupExerciseSettingListPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for FupExerciseSettingListPagingResultModel, can not map to FupExerciseSettingListPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
